import { IComponentOptions, IController } from 'angular';
import './gmc-chips.component.scss';

class GmcChipsController implements IController {
  static $inject = [];
  public result: string[] = [];
  public newItem: string;
  public placeholder = 'Enter value';

  constructor() {
  }

  $onInit() {
  }

  onInputKeypress( event ) {
    if ( event.keyCode === 13 ) {
      event.preventDefault();
    }
  }

  onInputKeyup( event ) {
    const value = event.target.value;
    if ( event.keyCode === 13 ) {
      if ( value.trim() ) {
        this.result.push(value);
        event.target.value = '';
      }
    }
    if ( event.keyCode === 8 && !value ) {
      this.result.pop();
    }
  }

  removeItem( index: number ) {
    this.result.splice(index, 1);
  }
}

export const GmcChipsComponent: IComponentOptions = {
  controller: GmcChipsController,
  template: require('./gmc-chips.component.html'),
  bindings: {
    result: '=?',
    placeholder: '@?'
  }
};



// WEBPACK FOOTER //
// ./app/shared/components/gmc-chips/gmc-chips.component.ts